import TileLayer from 'ol/layer/Tile.js';

class Tile extends TileLayer {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

export default Tile;